import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  class: "copyright mt-1",
  style: {"padding-bottom":"10px"}
}

import { ref } from 'vue'
import * as constant from "../constant"
import { connectState } from "../libs/connect"


const __default__ = {
  name: 'FootPage',
  props: {
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const transak = require('@/assets/transak.png');	
const buyCrypto = ref(false);
const transakUrl = ref(constant.transakUrl);

const onClickTransak = async () => {
	buyCrypto.value = true;
}

const onTransakOpen = async () => {
	if (connectState.userAddr.value === ''){
		transakUrl.value = constant.transakUrl;
	} else {
		transakUrl.value = constant.transakUrl + '&disableWalletAddressForm=true&walletAddress=' + connectState.userAddr.value;
	}
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_link, {
      type: "success",
      onClick: onClickTransak
    }, {
      default: _withCtx(() => [
        _createTextVNode("Buy Cryptos @"),
        _createVNode(_component_el_image, {
          src: _unref(transak),
          style: {"height":"25px"}
        }, null, 8, ["src"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_drawer, {
      modelValue: buyCrypto.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((buyCrypto).value = $event)),
      direction: "rtl",
      "destroy-on-close": "",
      onOpen: onTransakOpen
    }, {
      default: _withCtx(() => [
        _createElementVNode("iframe", {
          frameborder: "0",
          sandbox: "allow-scripts allow-same-origin allow-popups",
          src: transakUrl.value,
          style: {"height":"100%","width":"100%"}
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_link, {
        type: "success",
        href: "javascript:void(0);"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Build For Hackathons And Learnings")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})